import { Component, OnInit, Inject } from '@angular/core';
import { Reservas } from 'app/modules/common/entities/reservas';
import { CalanderFullService } from 'app/modules/Calander/services/calander-full.service';
import { ConfirmDialogModel } from './confirm-dialog-model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    standalone: false
})
export class ConfirmationDialogComponent {

  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
  confirmColor: string;
  cancelColor: string;

  constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    // Update view with given values
    this.title = data.title;
    this.message = data.message;
    this.confirmText = data.confirmText;
    this.cancelText = data.cancelText;
    this.confirmColor = data.confirmColor;
    this.cancelColor = data.cancelColor;  

  }

  ngOnInit() {
  }

  onConfirm(): void {
    this.dialogRef.close(this.data.confirmValue || true);
  } 

  onDismiss(): void {
    this.dialogRef.close(this.data.cancelValue || false);
  }
}
